var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-hamburger-3053071",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.871,
    height: 20,
    viewBox: "0 0 23.871 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12685",
    "data-name": "Path 12685",
    d: "M157.073,101.169a1,1,0,0,0,0-2H135.138a1,1,0,0,0,0,2Z",
    transform: "translate(-134.17 -99.17)",
    fill: "#1b2330"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12686",
    "data-name": "Path 12686",
    d: "M157.073,264.5a1,1,0,0,0,0-2H135.138a1,1,0,0,0,0,2Z",
    transform: "translate(-134.17 -253.5)",
    fill: "#1b2330"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12687",
    "data-name": "Path 12687",
    d: "M147.073,427.829a1,1,0,0,0,0-2H135.138a1,1,0,0,0,0,2Z",
    transform: "translate(-124.17 -407.829)",
    fill: "#1b2330"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounHamburger);
export default __webpack_public_path__ + "static/media/noun_hamburger.ca237760896e5d9b9f5641ee14854296.svg";
export { ForwardRef as ReactComponent };